import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserAuth } from "../../context/AuthContext";
import { useLang } from "../../i18n/LanguageContext";

/**
 * Interrupteur Élève / Prof.
 * - compact : petite pilule pour le header
 * - sinon   : version large pour la page Compte
 */
const ModeSwitch = ({ compact = false, onSwitched }) => {
  const { user, currentMode, switchMode } = UserAuth();
  const navigate = useNavigate();
  const { t } = useLang();
  const [busy, setBusy] = useState(false);
  const [askConfirm, setAskConfirm] = useState(false);

  if (!user?.hasProfile || currentMode === "admin") return null;

  const choose = async (mode) => {
    if (mode === currentMode || busy) return;
    // Première fois en prof : petite confirmation
    if (mode === "prof" && user.role === 2 && !askConfirm) {
      setAskConfirm(true);
      return;
    }
    setBusy(true);
    try {
      await switchMode(mode);
      setAskConfirm(false);
      onSwitched && onSwitched(mode);
      navigate("/mes_cours");
    } catch (e) {
      console.error(e);
    } finally {
      setBusy(false);
    }
  };

  const btn = (mode, label) => {
    const active = currentMode === mode;
    return (
      <button
        type="button"
        onClick={() => choose(mode)}
        disabled={busy}
        aria-pressed={active}
        className={`${compact ? "px-3 py-1.5 text-xs" : "flex-1 px-4 py-2.5 text-sm"} rounded-full font-semibold transition-all ${
          active
            ? mode === "prof"
              ? "bg-or text-prune-deep shadow"
              : "bg-prune text-white shadow"
            : "text-stone-600 hover:text-prune"
        }`}
      >
        {label}
      </button>
    );
  };

  return (
    <div className={compact ? "" : "w-full"}>
      <div
        className={`flex items-center gap-1 rounded-full p-1 ${compact ? "" : "w-full"}`}
        style={{ background: "#e8e2d9" }}
        title={t("Changer de mode")}
      >
        {btn("eleve", compact ? `🎓 ${t("Élève")}` : `🎓 ${t("Mode élève")}`)}
        {btn("prof", compact ? `🧑‍🏫 ${t("Prof")}` : `🧑‍🏫 ${t("Mode prof")}`)}
      </div>

      {askConfirm && (
        <div className={`${compact ? "absolute right-4 mt-2 w-72 z-50" : "mt-3"} bg-white rounded-xl shadow-lg border border-stone-100 p-4 text-left`}>
          <p className="text-sm text-stone-700 mb-3">
            {t("Activer le mode prof ? Votre profil apparaîtra dans « Nos professeurs » et vous pourrez créer des cours. Vous pourrez toujours revenir en mode élève.")}
          </p>
          <div className="flex gap-2">
            <button
              onClick={() => choose("prof")}
              disabled={busy}
              className="flex-1 py-2 rounded-full bg-or text-prune-deep text-sm font-semibold hover:bg-or-dark"
            >
              {busy ? "..." : t("Oui, devenir prof")}
            </button>
            <button
              onClick={() => setAskConfirm(false)}
              className="flex-1 py-2 rounded-full bg-stone-100 text-stone-600 text-sm font-semibold hover:bg-stone-200"
            >
              {t("Annuler")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ModeSwitch;
